import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    login:false,
    token:''
  },
  mutations: {
    setActLogin(state,token){
      state.login = true;
      state.token = token;
    },
    setOutActLogin(state){
      state.login = false;
    }
  },
  actions: {
    actInLogin({commit},token){
      commit('setActLogin',token);
    },
    actOutLogin({commit}){
      commit('setOutActLogin');
    }
  },
  modules: {
  }
})
